// HKDSE 2023 Paper 1 Knowledge Graph Samples - Complete Combined Set
// Merged from hkdse2023Samples_complete.js and hkdse2023Samples_complete_part2.js

import { hkdse2023Samples_complete } from './hkdse2023Samples_complete.js';
import { hkdse2023Samples_complete_part2 } from './hkdse2023Samples_complete_part2.js';

export const hkdse2023Samples_complete_combined = {
  ...hkdse2023Samples_complete,
  ...hkdse2023Samples_complete_part2
};

export { hkdse2023Samples_complete, hkdse2023Samples_complete_part2 }; 